// localStorage-based session persistence, scoped per user.
// Only non-sensitive canvas state is stored (polygon, rotation, sector count, room markers, remote image URL).
// Auth tokens live exclusively in httpOnly cookies and are never written here.
const key = (userId) => `vastu_session_v2:${userId || "anon"}`;

export function saveSession(userId, data) {
  try {
    localStorage.setItem(key(userId), JSON.stringify(data));
    return true;
  } catch (e) {
    return false;
  }
}

export function loadSession(userId) {
  try {
    const s = localStorage.getItem(key(userId));
    if (!s) return null;
    return JSON.parse(s);
  } catch (e) {
    return null;
  }
}

export function clearSession(userId) {
  localStorage.removeItem(key(userId));
}
